import createVueComponent from '../createVueComponent';

const Copyleft = createVueComponent('CopyleftIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M9 9.4a4 4 0 1 1 0 5.25', key: 'cap0i8' }],
]);

export default Copyleft;
